import { PatentYear } from "./patent-year";
export default PatentYear;
